import { ChevronRight } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

const AdminMore = () => {
  const navigate = useNavigate();

  const handleSignOut = () => {
    navigate("/");
  };

  const goToProfile = () => {
    navigate("/admin/profile");
  };
  const goToBirthdays = () => {
    navigate("/admin/birthdays");
  };
  const goToGatherings = () => {
    navigate("/admin/gatherings");
  };
  const goToContributions = () => {
    navigate("/admin/contributions");
  };
  const goToHistory = () => {
    navigate("/admin/history");
  };
  
  return (
    <>
      <p style={{ fontFamily: "Open Sans", fontSize: "14" }}>More</p>
      <div
      onClick={goToProfile}
        style={{
          alignItems: "center",
          paddingInline: "10px",
          marginTop: "10px",
          flexDirection: "row",
          display: "flex",
          justifyContent: "space-between",
          backgroundColor: "#779d38",
          height: "50px",
          width: "100%",
          borderRadius: "5px",
        }}
      >
        <p
          style={{
            fontFamily: "Open Sans",
            color: "#ffffff",
            marginTop: "7px",
          }}
        >
          Profile
        </p>
        <ChevronRight size={17} style={{ color: "#ffffff" }} />
      </div>
      <div
      onClick={goToBirthdays}
        style={{
          alignItems: "center",
          paddingInline: "10px",
          marginTop: "10px",
          flexDirection: "row",
          display: "flex",
          justifyContent: "space-between",
          backgroundColor: "#779d38",
          height: "50px",
          width: "100%",
          borderRadius: "5px",
        }}
      >
        <p
          style={{
            fontFamily: "Open Sans",
            color: "#ffffff",
            marginTop: "7px",
          }}
        >
          Birthdays
        </p>
        <ChevronRight size={17} style={{ color: "#ffffff" }} />
      </div>
      <div
      onClick={goToGatherings}
        style={{
          alignItems: "center",
          paddingInline: "10px",
          marginTop: "10px",
          flexDirection: "row",
          display: "flex",
          justifyContent: "space-between",
          backgroundColor: "#779d38",
          height: "50px",
          width: "100%",
          borderRadius: "5px",
        }}
      >
        <p
          style={{
            fontFamily: "Open Sans",
            color: "#ffffff",
            marginTop: "7px",
          }}
        >
          Gatherings
        </p>
        <ChevronRight size={17} style={{ color: "#ffffff" }} />
      </div>
     
      <div
      onClick={goToContributions}
        style={{
          alignItems: "center",
          paddingInline: "10px",
          marginTop: "10px",
          flexDirection: "row",
          display: "flex",
          justifyContent: "space-between",
          backgroundColor: "#779d38",
          height: "50px",
          width: "100%",
          borderRadius: "5px",
        }}
      >
        <p
          style={{
            fontFamily: "Open Sans",
            color: "#ffffff",
            marginTop: "7px",
          }}
        >
          Contributions
        </p>
        <ChevronRight size={17} style={{ color: "#ffffff" }} />
      </div>
      <div
      onClick={goToHistory}
        style={{
          alignItems: "center",
          paddingInline: "10px",
          marginTop: "10px",
          flexDirection: "row",
          display: "flex",
          justifyContent: "space-between",
          backgroundColor: "#779d38",
          height: "50px",
          width: "100%",
          borderRadius: "5px",
        }}
      >
        <p
          style={{
            fontFamily: "Open Sans",
            color: "#ffffff",
            marginTop: "7px",
          }}
        >
          Family History
        </p>
        <ChevronRight size={17} style={{ color: "#ffffff" }} />
      </div>
      <div
        onClick={() => handleSignOut()}
        style={{
          alignItems: "center",
          paddingInline: "10px",
          marginTop: "10px",
          flexDirection: "row",
          display: "flex",
          justifyContent: "space-between",
          backgroundColor: "#779d38",
          height: "50px",
          width: "100%",
          borderRadius: "5px",
        }}
      >
        <p
          style={{
            fontFamily: "Open Sans",
            color: "#ffffff",
            marginTop: "7px",
          }}
        >
          Sign Out
        </p>
        <ChevronRight size={17} style={{ color: "#ffffff" }} />
      </div>
    </>
  );
};

export default AdminMore;
